/**
 * @license
 * Copyright Akveo. All Rights Reserved.
 * Licensed under the MIT License. See License.txt in the project root for license information.
 */

import {
  NbAuthJWTToken,
  NbAuthStrategyOptions,
  NbPasswordStrategyMessage,
  NbPasswordStrategyModule,
  NbStrategyToken,
} from '@nebular/auth';

export class NbFirebaseIdentityProviderStrategyOptions extends NbAuthStrategyOptions {
  override token?: NbStrategyToken = {
    class: NbAuthJWTToken,
  };
  logout?: boolean | NbPasswordStrategyModule = {
    redirect: {
      success: '/',
      failure: null,
    },
    defaultErrors: ['Something went wrong, please try again.'],
    defaultMessages: ['You have been successfully logged out.'],
  };
  authenticate?: boolean | NbPasswordStrategyModule = {
    redirect: {
      success: '/',
      failure: null,
    },
    defaultErrors: ['Something went wrong, please try again.'],
    defaultMessages: ['You have been successfully authenticated.'],
  };
  errors?: NbPasswordStrategyMessage = {
    key: 'message',
    getter: (
      module: string,
      res: any,
      options: NbFirebaseIdentityProviderStrategyOptions,
    ) => (options as any)[module].defaultErrors,
  };
  messages?: NbPasswordStrategyMessage = {
    key: 'message',
    getter: (
      module: string,
      res: any,
      options: NbFirebaseIdentityProviderStrategyOptions,
    ) => {
      return (options as any)[module].defaultMessages;
    },
  };
  scopes?: string[] = [];
  customParameters?: Record<string, string> = {};
}
